import NeonRelayGame from './NeonRelayGame';
import { neonRelayDefinition } from './neonRelayDefinition';

const neonRelayIcons = {
  courier: {
    id: 'neon-relay',
    src: `${process.env.PUBLIC_URL}/game-icons/neon-relay.png`,
  },
  pulse: {
    id: 'neon-relay-pulse',
    baseId: 'neon-relay',
    src: `${process.env.PUBLIC_URL}/game-icons/neon-relay-pulse.png`,
  },
  sprinter: {
    id: 'neon-relay-sprinter',
    baseId: 'neon-relay',
    src: `${process.env.PUBLIC_URL}/game-icons/neon-relay-sprinter.png`,
  },
};

export const neonRelayGameModule = {
  id: neonRelayDefinition.id,
  name: neonRelayDefinition.name,
  summary: neonRelayDefinition.summary,
  component: NeonRelayGame,
  definition: neonRelayDefinition,
  accent: 'yellow',
  icon: neonRelayIcons.courier,
  releaseState: 'released',
  controls: {
    movement: 'horizontal-lanes',
    actions: ['confirm'],
    notes: 'Left/right lane switching.',
  },
  playableIcons: [
    { id: 'neon-relay', name: 'Courier', icon: neonRelayIcons.courier },
    { id: 'neon-relay-pulse', name: 'Pulse', icon: neonRelayIcons.pulse },
    { id: 'neon-relay-sprinter', name: 'Sprinter', icon: neonRelayIcons.sprinter },
  ],
};
